export const getRouteLinkIndexAdmin = () => {
  const navItem = [
    {
      title: "Dashboard",
      link: "/dashboard",
    },
    {
      title: "My Profile",
      link: "/myprofile",
    },
  ];
  if (typeof window === "undefined") return null;
  const currentPath = window.location.pathname;
  const currentItem = navItem.find((item) => item.link === currentPath);
  return currentItem || null;
};
